import { FilterOperator, FilterType, SelectItem } from '@do/common-interfaces';
import { marker } from '@do/ngx-translate-extract-marker';

export interface OperatorItem extends SelectItem {
  filters: FilterType[];
  value: FilterOperator;
  // apply: (value: any, valueToCompare: any) => boolean;
}

// Date: equals, notEqual, lessThan, greaterThan, inRange, empty
// Numeri:  equals, notEqual, lessThan, lessThanOrEqual, greaterThan, greaterThanOrEqual, inRange, empty
// Testi: equals, notEqual, contains, notContains, startsWith, endsWith, empty

const allFilters = [
  FilterType.text,
  FilterType.date,
  FilterType.datetime,
  FilterType.boolean,
  FilterType.number,
  FilterType.enum,
  FilterType.autocomplete,
];

const dateAndNumbers = [
  FilterType.date,
  FilterType.datetime,
  FilterType.number,
];

const numbers = [FilterType.number];

export const OPERATORS: OperatorItem[] = [
  // {
  //   value: undefined,
  //   description: '',
  //   filters: [...allFilters],
  //   // apply: () => true
  // },
  {
    value: FilterOperator.contains,
    description: marker('contains'),
    filters: [FilterType.text],
    // apply: (value: any, valueToCompare: any) =>
    //   value.toLowerCase().indexOf(valueToCompare.toLowerCase()) >= 0,
  },
  {
    value: FilterOperator.notContains,
    description: marker('not contains'),
    filters: [FilterType.text],
    // apply: (value: any, valueToCompare: any) =>
    //   value.toLowerCase().indexOf(valueToCompare.toLowerCase()) < 0,
  },
  {
    value: FilterOperator.equals,
    description: marker('equal to'),
    filters: [...allFilters],
    // apply: (value: any, valueToCompare: any) =>
    //   value === valueToCompare.toLowerCase,
  },
  {
    value: FilterOperator.notEqual,
    description: marker('different from'),
    filters: [...allFilters],
    // apply: (value: any, valueToCompare: any) => value != valueToCompare,
  },
  {
    value: FilterOperator.startsWith,
    description: marker('starts with'),
    filters: [FilterType.text],
    // apply: (value: any, valueToCompare: any) =>
    //   value.toLowerCase().startsWith(valueToCompare.toLowerCase()),
  },
  {
    value: FilterOperator.endsWith,
    description: marker('ends with'),
    filters: [FilterType.text],
    // apply: (value: any, valueToCompare: any) =>
    //   value.toLowerCase().endsWith(valueToCompare.toLowerCase()),
  },
  {
    value: FilterOperator.blank,
    description: marker('empty'),
    filters: [...allFilters],
  },
  {
    value: FilterOperator.notBlank,
    description: marker('is not empty'),
    filters: [...allFilters],
  },
  {
    value: FilterOperator.lessThan,
    description: marker('less than'),
    filters: [...dateAndNumbers],
  },
  {
    value: FilterOperator.lessThanOrEqual,
    description: marker('less than or equal to'),
    filters: [...numbers],
  },
  {
    value: FilterOperator.greaterThan,
    description: marker('greater than'),
    filters: [...dateAndNumbers],
  },
  {
    value: FilterOperator.greaterThanOrEqual,
    description: marker('greater than or equal'),
    filters: [...numbers],
  },
  {
    value: FilterOperator.inRange,
    description: marker('between'),
    filters: [...dateAndNumbers],
  },
];
